import { render, staticRenderFns } from "./SocialXIcon.vue?vue&type=template&id=26569437&"
import script from "./SocialXIcon.vue?vue&type=script&lang=js&"
export * from "./SocialXIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports